import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Alert, Card, CardBody, Col, Container, Row } from 'reactstrap';

// Redux
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// availity-reactstrap-validation
import { AvField, AvForm } from 'availity-reactstrap-validation';

// actions
import { apiError, loginUser } from '../../store/actions';

// import images
import profile from '../../assets/images/profile-img.png';
import logo from '../../assets/images/logo.png';
// import lightlogo from "../../assets/images/logo-light.svg"
import PageLoader from '../../components/Loaders/pageLoader';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.loginUser(values, this.props.history);
  }

  componentDidMount() {
    this.props.apiError('');
  }

  render() {
    return (
      <React.Fragment>
        {/* {profileData.length === 0 && loading && <PageLoader />} */}
        {<PageLoader progress={!this.props.loading && { step: 'Completed', time: 100 }} isLoading={this.props.loading} />}
        <div className='home-btn d-none d-sm-block'>
          <Link to='/' className='text-dark'>
            <i className='bx bx-home h2' />
          </Link>
        </div>
        <div className='account-pages my-5 pt-sm-5'>
          <Container>
            <Row className='justify-content-center'>
              <Col md={8} lg={6} xl={5}>
                <Card className='overflow-hidden'>
                  <div className='bg-primary bg-soft'>
                    <Row>
                      <Col className='col-8'>
                        <div className='text-primary p-5'>
                          <h5 className='text-primary'>Welcome Back !</h5>
                          <p>Sign in to continue to Korupharma.</p>
                        </div>
                      </Col>
                      <Col className='col-4 align-self-end'>
                        <img src={profile} alt='' className='img-fluid' />
                      </Col>
                    </Row>
                  </div>
                  <CardBody className='pt-0'>
                    <div className='auth-logo'>
                      <Link to='/' className='auth-logo-dark'>
                        <div className='avatar-md profile-user-wid mb-4'>
                          <span className='avatar-title rounded-circle bg-soft'>
                            <img src={logo} alt='' className='' height='34' />
                          </span>
                        </div>
                      </Link>
                    </div>
                    <div className='p-2'>
                      <AvForm className='form-horizontal' onValidSubmit={this.handleValidSubmit}>
                        {this.props.error && this.props.error ? <Alert color='danger'>{this.props.error}</Alert> : null}

                        <div className='mb-3'>
                          <AvField
                            name='workEmail'
                            // name="email"
                            label='Email'
                            value=''
                            className='form-control'
                            placeholder='Enter email'
                            type='email'
                            required
                          />
                        </div>

                        <div className='mb-3'>
                          <AvField name='password' label='Password' value='' type='password' required placeholder='Enter Password' />
                          {/*default password test123 */}
                        </div>

                        <div className='mt-4 d-grid'>
                          <button className='btn btn-primary btn-block' type='submit'>
                            Log In
                          </button>
                        </div>

                        <div className='mt-4 text-center'>
                          <Link to='/forgot-password' className='text-muted'>
                            <i className='mdi mdi-lock me-1' /> Forgot your password?
                          </Link>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                <div className='mt-3 text-center'>
                  <p>
                    © {new Date().getFullYear()} Korupharma. Crafted with <i className='mdi mdi-heart text-danger' /> by Us
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func
};

const mapStateToProps = (state) => {
  const { error, loading } = state.Login;
  return { error, loading };
};

export default withRouter(connect(mapStateToProps, { loginUser, apiError })(Login));
